import {generateClient} from 'aws-amplify/api';
import {screenshotsApiConfig} from "./config/index.ts";

export const screenshotsApiClient = generateClient({
    endpoint: screenshotsApiConfig.endpoint,
    region: screenshotsApiConfig.region,
    authMode: 'userPool'
});
